import React from 'react'
import ServicesHeader from 'vendors/components/services/ServicesHeader'
import ServicesList from 'vendors/components/services/ServicesList'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { Link as RouterLink, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const VendorServicesStep: React.FC<{ baseUrl: string }> = ({ baseUrl }) => {
  const { vendorId } = useParams<{ vendorId: string }>()
  const { t } = useTranslation()

  return (
    <Box sx={{ mx: 2 }}>
      <Box sx={{ backgroundColor: 'common.white', pb: 3, zIndex: 1 }}>
        <ServicesHeader />
      </Box>
      <ServicesList vendorId={vendorId ?? ''} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mb: 2
        }}
      >
        <Button sx={{ mt: 2 }} component={RouterLink} to={`${baseUrl}/${vendorId}/region`} variant="contained">
          {t('next')}
        </Button>
      </Box>
    </Box>
  )
}

export default VendorServicesStep
